export enum MarketplaceSubscriptionType {
    SubscriptionTypeApp = 'app',
    SubscriptionTypeService = 'service',
}
